module.exports = __webpack_public_path__ + "static/img/header_phone.e03fa63d.svg";